<template>
  <div class="customer-list">
    <Search
      @getHeight="getHeight"
      @saveSet="saveSet"
      width="100px"
      :isquery="true"
      :tableConfig="tableConfig"
      :advancedQuery="true"
      :isSort="false"
      :functionBtn="true"
      :isDel="false"
      :isAdd="false"
      :showDel="false"
      :showSort="false"
      :showAdd="false"
      ref="Search"
      searchName="CompanyReferrerCarPage"
    >
      <template v-slot:left>
        <el-col :lg="12" :md="12" :sm="12" :xs="12">
          <el-form-item label="开卡银行">
            <el-select
              filterable
              v-model="searchForm.bankId"
              clearable
              style="width: 100%"
              placeholder="请选择开卡银行"
            >
              <el-option
                v-for="item in BankList"
                :key="item.Id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :md="12" :sm="12" :xs="12">
          <el-form-item label="关键字">
            <el-input
              v-model="searchForm.keyWord"
              clearable
              @keyup.enter.native="$refs.Search.handleSearch"
              placeholder="请输入关键字查询"
            ></el-input>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:center>
        <el-button
          size="small "
          icon="el-icon-back"
          type="success"
          plain
          v-if="verifyPermission('Select')"
          :loading="submitLoading"
          @click="noteCard"
          >前往贷款</el-button
        >
        <el-button
          size="small "
          icon="el-icon-message"
          type="success"
          plain
          :loading="submitLoading"
          v-if="verifyPermission('Add')"
          @click="notifyCard"
          >贷款通知</el-button
        >
        <el-button
          size="small "
          icon="el-icon-refresh"
          type="success"
          plain
          disabled
          :loading="submitLoading"
          v-if="verifyPermission('Update')"
          @click="refreshState"
          >刷新状态</el-button
        >
        <el-button
          size="small "
          icon="el-icon-edit-outline"
          type="success"
          plain
          :loading="submitLoading"
          v-if="verifyPermission('Update')"
          @click="sharingRecords"
          >分享记录</el-button
        >
      </template>
      <template v-slot:advancedQuery>
        <el-col :lg="4" :md="6" :sm="12" :xs="24">
          <el-form-item label="状态">
            <el-select
              filterable
              v-model="searchForm.cardFollowState"
              clearable
              style="width: 100%"
              placeholder="请选择状态"
            >
              <el-option
                v-for="item in cardFollowStateList"
                :key="item.key"
                :label="item.description"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :lg="8" :md="10" :sm="12" :xs="24">
          <el-form-item label="最近通知时间" label-width="120px">
            <el-col :span="11">
              <el-date-picker
                style="width: 100%"
                v-model="searchForm.lastStartMsgDate"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择开始日期"
              >
              </el-date-picker>
            </el-col>
            <el-col :span="2">~</el-col>

            <el-col :span="11">
              <el-date-picker
                style="width: 100%"
                v-model="searchForm.lastEndMsgDate"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择结束日期"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-col>
        <el-col :lg="4" :md="6" :sm="12" :xs="24">
          <el-form-item label="人员状态">
            <el-select
              v-model="searchForm.workState"
              clearable
              style="width: 100%"
              placeholder="请选择状态"
            >
              <el-option
                v-for="item in workStateList"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="4" :md="6" :sm="12" :xs="24">
          <el-form-item label="是否异常">
            <el-select
              filterable
              v-model="searchForm.openCardState"
              clearable
              style="width: 100%"
              placeholder="请选择"
            >
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </template>
    </Search>
    <div class="customer-table-list page" v-loading="submitLoading">
      <MyTable
        :tableData="tableData"
        :tableConfig="tableConfig"
        :height="tableHeight"
        tableType="selection"
        @selectionChange="handleSelectionChange"
        :indexFlag="true"
      >
        <template v-slot:dataState="slotData">
          <div
            @click="showStatePopupPage(slotData.scope.row)"
            style="text-decoration: underline; cursor: pointer"
          >
            {{ slotData.scope.row.followStateText }}
            <!-- <div>
              {{
                slotData.scope.row.followOpDate &&
                slotData.scope.row.followOpDate.slice(0, 10)
              }}
            </div> -->
            <span v-if="slotData.scope.row.followStateTextOther"
              >（{{ slotData.scope.row.followStateTextOther }}）</span
            >
          </div>
        </template>
        <template v-slot:index="slotData">
          {{
            ($refs.pagination.currentPage - 1) * $refs.pagination.pageSize +
            slotData.scope.$index +
            1
          }}
        </template>
        <template v-slot:userWorkState="slotData">
          {{ slotData.scope.row.userWorkState | filterUserWorkState }}
        </template>
        <template v-slot:isStop="slotData">
          {{ slotData.scope.row.isStop ? "停用" : "启用" }}
        </template>
        <template v-slot:openCardState="slotData">
          <div v-if="slotData.scope.row.openCardState == 1">
            <el-tag size="small" type="danger">异常</el-tag>
          </div>
        </template>
        <template v-slot:time="slotData">
          {{
            slotData.scope.row.entryDate &&
            slotData.scope.row.entryDate.slice(0, 10)
          }}
        </template>
        <template v-slot:openCarResult="slotData">
          {{ slotData.scope.row.openCarResult ? "" : "-" }}
        </template>

        <template v-slot:moreOperation="slotData">
          <el-button
            @click="setCardState(slotData.scope.row)"
            size="small"
            type="primary"
            plain
            :loading="submitLoading"
            v-if="verifyPermission('Update')"
            icon="el-icon-setting"
            >设为异常</el-button
          >
        </template>
      </MyTable>
      <Pagination
        class="PagPosition"
        :total="total"
        @getNewData="CompanyReferrerCarPage"
        ref="pagination"
      />
      <el-dialog
        title="设为异常"
        :visible.sync="stateDialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="400px"
        class="colleague-dialog"
        @close="resetForm"
      >
        <el-form
          ref="form"
          :model="form"
          :inline="true"
          :rules="rules"
          label-width="auto"
          v-enterToNext="true"
        >
          <el-col :span="24">
            <el-form-item label="异常" prop="state">
              <el-radio-group v-model="form.state">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                style="width: 150%"
                type="textarea"
                :rows="4"
                placeholder="请输入备注"
                v-model="form.remark"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="
              () => {
                resetForm();
                stateDialogVisible = false;
              }
            "
            >关 闭</el-button
          >
          <el-button
            size="small "
            type="primary"
            :loading="submitLoading"
            @click="SetOpenCarState('form')"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        title="提示"
        :visible.sync="tipVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="700px"
        @close="closeDialog"
      >
        <div class="tip">
          已用小程序内通知的方式，通知对方在手机上通过银行APP进行开卡，可在一段时间后刷新状态，查看用户实际开卡情况！如用户未收到，您也可以直接将下述二维码转发给对方，进行开卡。如您打算使用其它通知，请勾选其它通知。
          <div v-for="item in bankInfoList" :key="item.id">
            <div
              style="
                margin-top: 10px;
                display: flex;
                justify-content: space-between;
              "
            >
              <div style="display: flex">
                {{ item.bankName }} &nbsp;
                <img :src="item.imgPath" alt="" v-if="$shareType == 2" />
                <div
                  :id="item.bankName"
                  :ref="item.bankName"
                  v-if="$shareType == 1"
                ></div>
              </div>
            </div>
          </div>
          <div class="checkGroup">
            <el-checkbox-group v-model="checkboxGroup" size="small">
              <el-checkbox label="1" border disabled>小程序通知</el-checkbox>
              <el-checkbox label="2" border>短信通知</el-checkbox>
              <el-checkbox label="3" border>小程序订阅通知</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="
              () => {
                resetForm();
                tipVisible = false;
              }
            "
            >关 闭</el-button
          >
          <el-button
            size="small "
            type="primary"
            :loading="submitLoading"
            @click="SendMsgAgain('form')"
            >确 定</el-button
          >
        </span>
      </el-dialog>

      <el-dialog
        title="状态记录"
        :visible.sync="showStateVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="showState"
        width="600px"
      >
        <MyTable
          :tableData="popupStateData"
          :tableConfig="popupStateDataConfig"
          height="300"
        >
        </MyTable>
        <Pagination
          class="PagPosition"
          :total="popupStateTotal"
          @getNewData="showStatePopupPage"
          ref="statePagination"
        />
      </el-dialog>
      <el-dialog
        title="分享记录"
        :visible.sync="shareVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="showState"
        width="900px"
      >
        <MyTable :tableData="shareData" :tableConfig="shareConfig" height="300">
          <!-- <template v-slot:createDate="slotData">
            {{
              slotData.scope.row.createDate &&
              slotData.scope.row.createDate.slice(0, 10)
            }}
          </template> -->
        </MyTable>
        <Pagination
          class="PagPosition"
          :total="shareTotal"
          @getNewData="sharePage"
          ref="sharePagination"
        />
      </el-dialog>
    </div>
    <!-- <notifyCard
      @colseDrawer="noticeDialogVisible = false"
      :visible.sync="noticeDialogVisible"
    /> -->
  </div>
</template>

<script>
import Search from "@/components/Search";
import MyTable from "@/components/Table";
import QRCode from "qrcodejs2";
import { baseUrl } from "../../request/url";
import { verifyPermissionMinix, GetUnlimitedQRCodeMinix } from "@/utils/mixin";
import { showWorkState, workStateList } from "../../utils/common";
export default {
  components: {
    Search,
    MyTable,
  },
  mixins: [verifyPermissionMinix, GetUnlimitedQRCodeMinix],
  data() {
    return {
      tableName: "personalLoans",
      popupStateDataConfig: [
        {
          field: "opDate",
          label: "日期",
          align: "center",
          width: 170,
          flag: true,
        },
        {
          field: "stateText",
          label: "状态",
          align: "center",
          width: 250,
          flag: true,
        },
        {
          field: "remark",
          label: "备注",
          align: "center",
          flag: true,
        },
      ],
      tableConfig: [
        {
          field: "userName",
          label: "姓名",
          align: "center",
          width: 120,
          flag: true,
        },
        {
          field: "sex",
          label: "性别",
          align: "center",
          width: 90,
          flag: true,
        },
        {
          field: "identityCard",
          label: "身份证号",
          align: "center",
          width: 180,
          flag: true,
        },
        {
          field: "tel",
          label: "手机号码",
          align: "center",
          width: 140,
          flag: true,
        },
        {
          field: "userWorkState",
          label: "人员状态",
          align: "center",
          width: 120,
          flag: true,
          slotName: "userWorkState",
        },
        {
          field: "createUserName",
          label: "发起人",
          align: "center",
          width: 120,
          flag: true,
        },
        {
          field: "lastSendMsgBankName",
          label: "开卡银行",
          align: "center",
          width: 120,
          flag: true,
        },
        {
          field: "sendMsgCount",
          label: "通知次数",
          align: "center",
          width: 110,
          flag: true,
        },
        {
          field: "lastSendMsgTime",
          label: "最近通知时间",
          align: "center",

          width: 180,
          flag: true,
        },
        // {
        //   field: "cardNum",
        //   label: "开卡数量",
        //   align: "center",
        //   width: 110,
        //   flag: true,
        // },

        // {
        //   field: "makeCardState",
        //   label: "制卡状态",
        //   align: "center",
        //   width: 110,
        //   flag: true,
        // },
        // {
        //   field: "activateState",
        //   label: "激活状态",
        //   align: "center",
        //   width: 120,
        //   flag: true,
        // },

        {
          field: "dataState",
          label: "状态",
          align: "center",

          width: 180,
          flag: true,
          slotName: "dataState",
        },
        {
          field: "cardNumber",
          label: "卡号",
          align: "center",
          width: 180,
          flag: true,
        },
        // {
        //   field: "openCarResult",
        //   label: "开卡结果",
        //   align: "center",
        //   width: 110,
        //   slotName: "openCarResult",

        //   flag: true,
        // },
        {
          field: "openCardState",
          label: "是否异常",
          align: "center",
          slotName: "openCardState",
          width: 120,
          flag: true,
        },
        {
          field: "remark",
          label: "备注",
          align: "center",
          minWidth: 180,
          flag: true,
        },
        {
          label: "基本操作",
          slotName: "moreOperation",
          width: 160,
          align: "center",
          fixed: "right",
          flag: true,
        },
      ],
      shareConfig: [
        {
          field: "recommendUserName",
          label: "推荐人姓名",
          align: "center",
          flag: true,
        },
        {
          field: "userName",
          label: "申请人姓名",
          align: "center",

          flag: true,
        },
        {
          field: "tel",
          label: "手机号码",
          align: "center",

          flag: true,
        },
        {
          field: "identityCard",
          label: "身份证",
          align: "center",
          width: 180,
          flag: true,
        },
        {
          field: "createDate",
          label: "申请时间",
          width: 170,
          align: "center",
          flag: true,
        },
        {
          field: "bankName",
          label: "申请银行",
          align: "center",
          flag: true,
        },
        // {
        //   field: "bankBusinessName",
        //   label: "申请产品",
        //   align: "center",
        //   flag: true,
        // },
        // {
        //   field: "qrCodeUrl",
        //   label: "申请二维码",
        //   slotName: "qrCodeUrl",
        //   align: "center",
        //   flag: true,
        // },
      ],
      tipVisible: false,
      showStateVisible: false,
      form: {},
      checkboxGroup: ["1"],
      rules: {
        BankName: [
          {
            required: true,
            message: "请选择通知银行",
            trigger: ["blur", "change"],
          },
        ],
        state: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
          },
        ],
      },
      checked: true,
      id: "",
      tableHeight: "",
      submitLoading: false,
      stateDialogVisible: false,
      noticeDialogVisible: false,
      importVisible: false,
      userForm: {},
      shareVisible: false,
      shareData: [],
      shareTotal: 0,
      companyList: [],
      options: [],
      Ids: [],
      searchList: [],
      total: 0,
      loading: false,
      tableData: [],
      bankInfoList: [],
      searchForm: {},
      customerIds: [],
      companyId: "",
      BankList: [],
      popupStateData: [],
      popupStateTotal: 0,
      cardFollowStateList: [],
      workStateList: workStateList,
      CreditCardBusinessList: [],
      bankIdList: [],
      userAutoIntId: "",
      CompanyAutoIntId: "",
      //卡类型
      carType: 4,
      toPage: "",
    };
  },
  mounted() {
    console.log(this.$shareType);
    this.CompanyReferrerCarPage();
    this.getBankList();

    this.getCreditCardBusinessList();
    this.getCardFollowStateList();
    this.userAutoIntId = JSON.parse(
      window.localStorage.getItem("userInfo")
    ).autoIntId;
    this.CompanyAutoIntId = JSON.parse(
      window.localStorage.getItem("CompanyDetail")
    ).autoIntId;
    // this.getCompanyList();
    //初始化设置列的隐藏和排序方法
    if (localStorage.getItem(this.tableName)) {
      this.tableConfig = JSON.parse(localStorage.getItem(this.tableName));
      this.sortType = this.tableConfig.pop();
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = this.sortType;
        }
      });
    }
  },
  filters: {
    filterUserWorkState(num) {
      return showWorkState(num);
    },
  },
  methods: {
    // 分享分页
    sharePage() {
      this.loading = true;
      this.$nextTick(() => {
        let sendData = {};
        sendData = {
          pageIndex: this.$refs.sharePagination.currentPage,
          pageSize: this.$refs.sharePagination.pageSize,
          // bankId: this.searchForm.bankId,
          type: this.carType,
          // createStartDate: this.searchForm.createStartDate,
          // createEndDate: this.searchForm.createEndDate,
          // keyWord: this.searchForm.keyWord,
        };
        this.$api.manage.ServiceRecommendLogPage(sendData).then((res) => {
          if (!res.error) {
            console.log(res);
            this.loading = false;
            this.shareData = res.data.data;
            this.shareTotal = res.data.count;
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    // 分享记录
    sharingRecords() {
      this.shareVisible = true;
      this.sharePage();
    },
    closeDialog() {
      if (this.$shareType == 1) {
        this.bankInfoList.forEach((item) => {
          document.getElementById(item.bankName).innerHTML = "";
        });
      }
    },
    qrcode() {
      this.submitLoading = true;

      this.bankInfoList.forEach((item, i) => {
        if (this.$shareType == 1) {
          let qrcode = new QRCode(item.bankName, {
            width: 100, // 设置宽度，单位像素
            height: 100, // 设置高度，单位像素
            text:
              baseUrl.website +
              "/#/pages/webView/transferPage?id=" +
              item.bankAutoIntId +
              "-" +
              item.autoIntId +
              "-" +
              item.userAutoIntId +
              "-" +
              item.CompanyAutoIntId,
            // 设置二维码内容或跳转地址
          });
          console.log(
            baseUrl.website +
              "/#/pages/webView/transferPage?id=" +
              item.bankAutoIntId +
              "-" +
              item.autoIntId +
              "-" +
              item.userAutoIntId +
              "-" +
              item.CompanyAutoIntId
          );
          this.submitLoading = false;
        }
        if (this.$shareType == 2) {
          let sendData = {
            page: "pages/webView/transferPage",
            check_path: false,
            width: 150,
            scene:
              "id=" +
              item.bankAutoIntId +
              "-" +
              item.autoIntId +
              "-" +
              item.userAutoIntId +
              "-" +
              item.CompanyAutoIntId,
          };
          this.toPage = `${baseUrl.appletPage}?scene=${sendData.scene}`;
          this.GetUnlimitedQRCode(sendData).then((res) => {
            item.imgPath = "data:image/png;base64," + res;
            if (this.bankInfoList.length - 1 == i) {
              this.submitLoading = false;
            }
            this.tipVisible = true;
          });
        }
      });
    },
    getCreditCardBusinessList() {
      this.loading = true;

      this.$api.manage.WageCarBusiness().then((res) => {
        this.loading = false;

        if (res.error === false) {
          this.CreditCardBusinessList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    showStatePopupPage(data) {
      this.showStateVisible = true;
      this.$nextTick(() => {
        var params = {
          pageIndex: this.$refs.statePagination.currentPage,
          pageSize: this.$refs.statePagination.pageSize,
          crid: data.id,
        };
        this.$api.user.CompanyReferrerCardStatePage(params).then((res) => {
          if (res.error === false) {
            this.loading = false;
            this.popupStateData = res.data.data;
            this.popupStateTotal = res.data.count;
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    getCardFollowStateList() {
      let sendData = {
        loading: false,
      };
      this.$api.user.CardFollowStateList(sendData).then((res) => {
        console.log(res.data);
        if (res.error === false) {
          this.cardFollowStateList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    SendMsgAgain() {
      let sendData = {
        idList: this.Ids,
        carType: this.carType,
        msgType: this.checkboxGroup.join(),
        toPage: this.toPage,
      };
      this.submitLoading = true;
      this.$api.user.CompanyReferrerCarSendMsgAgain(sendData).then((res) => {
        if (res.error === false) {
          this.submitLoading = false;
          this.$message.success("通知成功");
          this.tipVisible = false;
          this.CompanyReferrerCarPage();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 刷新状态
    async refreshState() {
      this.submitLoading = true;
      for (var i = 0; i < this.tableData.length; i++) {
        let sendData = {
          crid: this.tableData[i].id,
        };
        if (this.tableData[i].followState) {
          await this.commitRefresh(sendData);
        }
        if (i == this.tableData.length - 1) {
          this.submitLoading = false;
          this.CompanyReferrerCarPage();
          this.$message.success("刷新成功");
        }
      }
    },
    async commitRefresh(param) {
      await this.$api.user
        .CompanyReferrerCarSyncBankCardStatu(param)
        .then((res) => {
          if (res.code === 0) {
            console.log(res);
          } else if (res.code < 0) {
            this.$message.error(res.msg);
          }
        });
    },
    // 获取银行列表
    getBankList() {
      let sendData = {
        loading: false,
      };
      this.$api.manage.CooperativeBank(sendData).then((res) => {
        if (res.error === false) {
          this.BankList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    noteCard() {
      // this.$router.push("/cardListIndex");
      this.$parent.noteCard(true);
    },
    SetOpenCarState(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        let sendData = {
          id: this.id,
          state: this.form.state,
          remark: this.form.remark,
        };
        this.submitLoading = true;

        this.$api.user
          .CompanyReferrerCarSetOpenCarState(sendData)
          .then((res) => {
            this.submitLoading = false;
            if (res.error === false) {
              this.CompanyReferrerCarPage();
              this.stateDialogVisible = false;
              this.resetForm();
            } else {
              this.$message.error(res.msg);
            }
          });
      });
    },
    resetForm() {
      this.$nextTick(() => {
        this.form = {};
        this.$refs.form.clearValidate();
      });
      confirm;
    },
    // 设置开卡状态
    setCardState(row) {
      this.stateDialogVisible = true;
      this.id = row.id;
      this.resetForm();
    },
    // 通知开卡
    notifyCard() {
      if (this.Ids.length <= 0) {
        return this.$message.warning("请至少选择一条数据");
      }
      this.bankInfoList = [];
      this.bankIdList.forEach((item) => {
        this.CreditCardBusinessList.forEach((element) => {
          if (element.bankId == item) {
            element.userAutoIntId = this.userAutoIntId;
            element.CompanyAutoIntId = this.CompanyAutoIntId;
            this.bankInfoList.push(element);
          }
        });
      });
      if (this.$shareType == 1) {
        this.tipVisible = true;
      }
      this.$nextTick(() => {
        this.qrcode();
      });
    },

    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        // let sendData = {
        //   firstId: this.firstId,
        //   parentId: this.userForm.parentId ? this.userForm.parentId : "",
        // };
        // this.$api.user.UpdateUserApplyParent(sendData).then((res) => {
        //   console.log(res);
        //   if (res.error === false) {
        //     this.$message.success("保存成功");
        //     this.CompanyReferrerCarPage();
        //   } else {
        //     this.$message.error(res.msg);
        //   }
        //   this.userDialogVisible = false;
        //   this.resetForm();
        // });
      });
    },
    //获取列的隐藏数据
    saveSet(checkList, type) {
      if (checkList) {
        this.tableConfig = JSON.parse(JSON.stringify(checkList));
      }
      this.sortType = type;
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = type;
        }
      });
    },
    //计算表格高度
    getHeight(height) {
      this.tableHeight = height;
    },
    //获取数据
    CompanyReferrerCarPage() {
      this.loading = true;
      let sendData = {};
      sendData = {
        pageIndex: this.$refs.pagination.currentPage,
        pageSize: this.$refs.pagination.pageSize,
        bankId: this.searchForm.bankId,
        carType: this.carType,
        lastStartMsgDate: this.searchForm.lastStartMsgDate,
        lastEndMsgDate: this.searchForm.lastEndMsgDate,
        openCardState: this.searchForm.openCardState,
        keyWord: this.searchForm.keyWord,
        workState: this.searchForm.workState,
        cardFollowState: this.searchForm.cardFollowState,
      };

      this.$api.user.CompanyReferrerCarPage(sendData).then((res) => {
        if (!res.error) {
          console.log(res);
          this.loading = false;
          this.tableData = res.data.data;
          this.total = res.data.count;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleSelectionChange(selection) {
      this.Ids = selection.map((v) => {
        return v.id;
      });
      this.bankIdList = [];
      selection.forEach((item) => {
        if (this.bankIdList.indexOf(item.bankId) === -1) {
          this.bankIdList.push(item.bankId);
        }
      });
    },
    // 无人员数据
    personnelTip() {
      this.$confirm("暂无人员数据,请前往人员管理处添加人员!", "提示", {
        confirmButtonText: "前往人员管理",
        cancelButtonText: "关 闭",
        type: "warning",
      })
        .then(() => {
          this.$router.push("/personnelList");
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="less" >
.showState .el-dialog__body {
  padding: 0 20px 50px !important;
}
.checkGroup {
  text-align: center;
  margin-top: 25px;

  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #409eff;
    border-color: #409eff;
  }
  .el-checkbox__label {
    display: initial;
  }
  .el-checkbox,
  .el-checkbox__input {
    display: initial;
  }
  .el-checkbox {
    margin-right: 10px;
  }
}
.customer-list {
  .upload-demo {
    .el-upload {
      width: 100% !important;
    }
    .el-upload-dragger {
      width: 100% !important;
    }
  }
}
</style>
<style lang="less" scoped>
// .el-form-item__label {
//   width: 60px !important;
// }
.tip {
  line-height: 25px;
  text-indent: 2em;
  img {
    width: 140px;
  }
}
.btn {
  margin-left: 15px;
}
.customer-list {
  .bankList {
    background-color: #fff;
    width: 300px;
    padding: 15px;
    border-right: 1px solid rgba(204, 204, 204, 0.555);
    .bank {
      border: 1px solid #ccc;
      padding: 10px;
      border-radius: 5px;
      img {
        width: 100%;
      }
      h3 {
        text-align: center;
      }
    }
  }
  .file,
  .table {
    width: 100%;
    .title {
      display: flex;
      align-items: center;

      .num {
        color: rgb(26, 210, 103);
        font-size: 22px;
        margin-right: 15px;
      }
    }

    .upload-demo {
      width: 100%;
      padding: 10px 70px;
      .el-upload-dragger {
        width: 100% !important;
      }
    }
    .result {
      padding: 10px 70px;
    }
  }

  .category {
    width: 200px;
    height: calc(100vh - 155px);
    background-color: #fff;
    border-radius: 6px;
    padding: 20px;
    margin-right: 20px;
    > div {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      border-bottom: 1px solid #ddd;
      font-weight: bold;
      font-size: 15px;
      img {
        width: 16px;
        margin-right: 5px;
      }
    }
    li {
      margin-top: 12px;
      cursor: pointer;
      &:hover {
        color: var(--theme-black);
        text-decoration: underline;
      }
    }
    .tab-active {
      color: #87481f !important;
      text-decoration: underline !important;
    }
  }
  .customer-table-list {
    width: calc(100%);
    height: calc(100vh - 155px);
  }
}
</style>
